<template>
  <b-card
    class="profile-header mb-2"
    :img-src="
      userData.cover || require('@/assets/images/fxlegends/partner-cover-2.jpg')
    "
    img-top
    alt="cover photo"
    body-class="p-0"
  >
    <div class="position-relative top-30">
      <div
        class="profile-img-container w-100 d-flex align-items-md-end rounded-circle"
      >
        <div class="rounded-avatar d-flex ml-md-3 ml-1">
          <b-img
            :src="userData.logo ? userData.logo : errorImage"
            @error="setAltImg"
            style="border: 2px solid #fbad25 !important"
            alt="profile photo"
            class="rounded-avatar p-25"
            width="84"
            height="84"
          />
          <!-- <div
            class="position-absolute cursor-pointer bottom-0 w-100 d-flex justify-content-center pb-2 avatar-btns"
          >
            <span
              class="text-primary text-lighten-2"
              v-b-tooltip.hover.top="'Edit avatar'"
              @click="$refs.refInputEl.click()"
            >
              <input
                ref="refInputEl"
                type="file"
                class="d-none"
                @input="changeAvatar"
                accept="image/*"
              />
              <feather-icon icon="EditIcon" />
            </span>
            <span
              class="ml-50 text-danger text-lighten-2"
              v-b-tooltip.hover.top="'Remove avatar'"
              @click="remove"
            >
              <feather-icon icon="TrashIcon" />
            </span>
          </div> -->
        </div>
        <div
          class="profile-title m-0 ml-50 d-flex flex-wrap flex-md-nowrap align-content-center align-items-center"
        >
          <h2 class="text-white d-flex align-items-center">
            {{ userData.first_name }}
          </h2>
          <div class="pl-1 pr-1 d-none d-md-block">
            <div
              class="bg-muted h-100"
              style="width: 1px !important; height: 15px !important"
            ></div>
          </div>
          <div class="d-flex flex-wrap">
            <p class="text-white mb-0 text-muted d-flex">
              {{ userData.email }}
            </p>
            <div
              class="align-items-center ml-md-50 ml-0 d-flex"
              v-if="userData.flag_url"
            >
              <b-img
                class="rounded-circle"
                style="height: 15px !important; width: 15px !important"
                :src="userData.flag_url || errorImage"
                @error="setAltImg"
                fluid
              />
              <b-badge
                variant="warning"
                v-if="userData.email_verified"
                style="padding: 0.1rem"
                class="rounded-circle ml-25"
              >
                <feather-icon
                  icon="CheckIcon"
                  style="width: 12px; height: 12px"
                />
              </b-badge>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="profile-header-nav py-25">
      <div class="d-flex align-items-center justify-content-end p-1">
        <feather-icon
          icon="EditIcon"
          size-md="28"
          size="20"
          class="cursor-pointer"
          @click="$router.push({ name: 'partners-edit-profile' })"
        />
      </div>
    </div>
  </b-card>
</template>

<script>
import {
  BCard,
  BImg,
  BNavbar,
  BNavbarToggle,
  BCollapse,
  BTabs,
  BNavItem,
  BButton,
  BBadge,
  VBTooltip,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";

export default {
  components: {
    BCard,
    BTabs,
    BButton,
    BNavItem,
    BNavbar,
    BNavbarToggle,
    BCollapse,
    BImg,
    BBadge,
  },
  directives: {
    Ripple,
    "b-tooltip": VBTooltip,
  },
  async created() {
    this.loading = true;
    await this.getProfile();
    this.loading = false;
  },
  data() {
    return {
      loading: false,
      userData: JSON.parse(localStorage.getItem("userData")),
      nationality: "",
    };
  },
  methods: {
    async remove() {
      try {
        const { data } = await this.$http.delete(
          `panel/profile/partner/logo?_method=patch`
        );
        await this.getProfile();
      } catch (err) {}
    },
    async changeAvatar(e) {
      try {
        let formData = new FormData();
        formData.append("logo", e.target.files[0]);
        const { data } = await this.$http.post(
          `panel/profile/partner/logo?_method=patch`,
          formData
        );
        await this.getProfile();
      } catch (err) {}
    },
    async getProfile() {
      try {
        const { data } = await this.$http.get("panel/profile/partner");

        await localStorage.setItem(
          "userData",
          JSON.stringify({
            ...data.partner.data,
            documents: data.documents.data,
            type: "partner",
          })
        );
        await this.$store.dispatch("auth/setUserData", {
          ...data.partner.data,
          documents: data.documents.data,
          type: "partner",
        });
        this.userData = {
          ...data.partner.data,
          documents: data.documents.data,
          type: "partner",
        };
        if (!this.userData.verified) {
          this.$router.push("/partner-registration").catch((err) => {});
        }
      } catch (err) {}
    },
  },
};
</script>
<style lang="scss" scoped>
.avatar {
  overflow: hidden;

  .avatar-btns {
    transform: translateY(100px);
    opacity: 0;
    transition: all 0.4s ease-out;
  }

  &:hover .avatar-btns {
    transform: translateY(0);
    opacity: 1;
  }
}
.top-30 {
  top: 25px;
}
.card-img-top {
  height: 400px;
}
@media (max-width: 575.98px) {
  .top-30 {
    top: 0px;
  }
  .card-img-top {
    height: 200px;
  }
}
</style>
